// src/redux/reducers/rootReducer.js
import { combineReducers } from 'redux';
import sidebarReducer from './sidebarReducer';
import baseUrlReducer from './baseUrlReducer';
import authReducer from './authReducer';
import siteReducer from './siteReducer';
import supportedparamReducer from './supportedparamReducer';
import alerttrendReducer from './alerttrendReducer';
import timerangeReducer from './timerangeReducer';
import tempnameReducer from './tempnameReducer';
import uiFeatureReducer from './uiFeatureReducer';
import refreshReducer from './refreshReducer';
import pagerefreshReducer from './pagerefreshReducer';
import featureListReducer from './featureListReducer';
import baseUrlSteponeWSReducer from './baseUrlSteponeWSReducer';
import websocketReducer from './websocketReducer'
import commandReducer from './commandReducer';
import markerReducer from './markerReducer';
import dataCollectionurlReducer from './dataCollectionurlReducer';
import darkModeReducer from './darkModeReducer';
import companynameReducer from './companyNameReducer';
import companyaddressReducer from './companyAddressReducer';
import latlongReducer from './latlongReducer';
import timeReducer from './timeReducer';
import copyrightReducer from './copyrightReducer';
import callDetailReducer from './callDetailReducer';
import baseUrlSensotoAIReducer from './baseUrlSensotoAIReducer';
import mapkeyReducer from './mapkeyReducer';
import baseUrlbatteryReducer from './baseUrlbatteryReducer';
import gpxFormatReducer from './gpxFormatReducer';

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  baseUrl: baseUrlReducer,
  baseUrlSteponeWS:baseUrlSteponeWSReducer,
  baseUrlSensotoAI:baseUrlSensotoAIReducer,
  datacollectionurl:dataCollectionurlReducer,
  websocketUrl:websocketReducer,
  auth :authReducer,
  site: siteReducer,
  supported:supportedparamReducer,
  alerttrend:alerttrendReducer,
  timerange:timerangeReducer,
  tempname:tempnameReducer,
  uifeature:uiFeatureReducer,
  refresh: refreshReducer,
  pagerefresh:pagerefreshReducer,
  featureaccess:featureListReducer,
  command: commandReducer, 
  markernumber:markerReducer,
  darkMode: darkModeReducer,
  companyname:companynameReducer,
  companyaddress:companyaddressReducer,
  latlong:latlongReducer,
  time: timeReducer,
  copyrightyear:copyrightReducer,
  callDetail: callDetailReducer,
  mapKey:mapkeyReducer,
  batteryAPIURL:baseUrlbatteryReducer,
  gpxFormat: gpxFormatReducer,
});

export default rootReducer;
